<template>
  <div class="invoices">
    <div class="main-wrapper">
      <layout-header></layout-header>
      <layout-sidebar></layout-sidebar>
      <!-- Page Wrapper -->
      <div class="page-wrapper">
        <!-- Page Content -->
        <div class="content container-fluid">
          <!-- Page Header -->
          <div class="page-header">
            <div class="row align-items-center">
              <div class="col">
                <h3 class="page-title">
                  <span data-tour-step="1">Broadcast</span>
                </h3>
                <ul class="breadcrumb">
                  <li class="breadcrumb-item">
                    <router-link to="/index">Dashboard</router-link>
                  </li>
                  <li class="breadcrumb-item active">Broadcast</li>
                </ul>
              </div>
              <div class="col-auto float-right ml-auto">
                <div class="dropdown action-label">
                  <a class="btn add-btn btn-rounded dropdown-toggle" href="#" data-toggle="dropdown"
                    aria-expanded="false">
                    <i class="fa fa-bullhorn"></i> Broadcast
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <router-link :to="'/message_report/broadcast/wizard'" class="dropdown-item divider">
                      <i class="fa text-success"></i> New
                    </router-link>
                    <router-link :to="'/message_report/broadcast/wizard_import'" class="dropdown-item divider">
                      <i class="fa text-success"></i> Import
                    </router-link>
                  </div>
                </div>

                <!-- <router-link data-tour-step="2" class="btn add-btn" :to="'/message_report/broadcast/wizard'">
                  <i class="fa fa-bullhorn"></i> Broadcast Baru
                </router-link> -->
                <!-- <a
                  ref="formBc"
                  class="btn add-btn"
                  @click="showBroadcast(true)"
                  href="#"
                  data-toggle="modal"
                  data-target="#add_broadcast"
                >
                  <i class="fa fa-bullhorn"></i> Add
                </a>-->
                <a v-show="false" ref="formBcEdit" class="btn add-btn" @click="showBroadcast(false)" href="#"
                  data-toggle="modal" data-target="#add_broadcast">
                  <i class="fa fa-bullhorn"></i> Edit
                </a>
              </div>
            </div>
          </div>
          <!-- /Page Header -->

          <div class="row">
            <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12">
              <ul class="nav float-right custom-menu">
                <li class="dropdown dropdown-action">
                  <a href class="dropdown-toggle" data-toggle="dropdown" aria-expanded="false">
                    <i class="material-icons">more_vert</i>
                  </a>
                  <div class="dropdown-menu dropdown-menu-right">
                    <a @click.prevent="tourShow" class="dropdown-item" href="javascript:void(0)">Tour Guide</a>
                    <a target="_blank" class="dropdown-item"
                      href="https://www.youtube.com/watch?v=aAvN-uBTVKY&ab_channel=waajoindonesia">Tutorial Video</a>
                  </div>
                </li>
              </ul>
            </div>
          </div>
          <!-- Search Filter -->
          <div class="row filter-row" data-tour-step="3">
            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus">
                <input class="form-control floating" v-model="serverParams.columnFilters.period" type="month" />
                <label class="focus-label">Created</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3">
              <div class="form-group">
                <!-- <input
                  class="form-control floating"
                  v-model="serverParams.columnFilters.license_id"
                  type="text"
                />
                <label class="focus-label">License ID</label>-->

                <multiselect :class="'form-control'" v-model="selectedContact" id="ajax" label="license_name"
                  track-by="id" :placeholder="''" :multiple="true" open-direction="bottom" :custom-label="customLabel"
                  :options="contactOptions" :searchable="true" :loading="isLoading" :internal-search="false"
                  :close-on-select="false" :options-limit="300" :limit="3" :limit-text="limitText" :max-height="600"
                  :show-no-results="true" :hide-selected="true" @search-change="asyncFind" :show-labels="false">
                  <template slot="tag" slot-scope="{ option, remove }">
                    <span class="custom__tag">
                      <span>{{ option.license_name }}</span>
                      <span class="custom__remove" @click="remove(option)">❌</span>
                    </span>
                  </template>
                  <template slot="clear" slot-scope="props">
                    <div class="multiselect__clear" v-if="selectedContact.length"
                      @mousedown.prevent.stop="clearAll(props.search)"></div>
                  </template>
                  <span slot="noResult">Oops! No elements found.</span>
                </multiselect>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <div class="form-group form-focus select-focus">
                <select class="form-control" v-model="serverParams.columnFilters.is_send">
                  <option :value="''">-- Select --</option>
                  <option :value="'running'">On Going</option>
                  <option :value="1">Sent</option>
                  <option :value="0">Draft</option>
                </select>
                <label class="focus-label">Status</label>
              </div>
            </div>
            <div class="col-sm-6 col-md-3" v-if="serverParams.columnFilters.is_send == 'running'">
              <div class="form-group form-focus select-focus">
                <select class="form-control" v-model="serverParams.columnFilters.is_running">
                  <option :value="''">-- Select --</option>
                  <option :value="'all'">All</option>
                  <option :value="'schedule'">Schedule</option>
                  <option :value="'recurring'">Recurring</option>
                </select>
                <label class="focus-label">On Going</label>
              </div>
            </div>

            <div class="col-sm-6 col-md-3">
              <a href="javascript:void(0)" @click.prevent="searchData" class="btn btn-success btn-block">Search</a>
            </div>
          </div>
          <div class="row filter-row" v-if="selectedTable.length">
            <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button :disabled="isLoading" @click.prevent="actionStop" class="btn btn-danger btn-block">
                  <i class="la la-stop"></i> Stop
                </button>
              </div>
            </div>
            <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button :disabled="isLoading" @click.prevent="actionDelete" class="btn btn-danger btn-block">
                  <i class="la la-trash"></i> Remove
                </button>
              </div>
            </div>

            <!-- <div class="col-sm-6 col-md-2">
              <div class="form-group">
                <button
                  :disabled="isLoading"
                  @click.prevent="actionDraft"
                  class="btn btn-warning btn-block"
                >
                  <i class="la la-pause"></i> Draft
                </button>
              </div>
            </div> -->
            <div class="col-sm-6 col-md-8">
              <div class="text-right">
                <!-- <button class="btn btn-success btn-block">Scrape</button>-->
                <a @click.prevent="hideActions" class="btn btn-xs">
                  <i class="fa fa-close"></i> Close
                </a>
              </div>
            </div>
          </div>
          <!-- /Search Filter -->
          <div class="row">
            <div class="col-md-12">
              <div class="alert alert-warning">
                <ul>
                  <li>Schedule broadcast mungkin akan delay sekitar 3-5 menit.</li>
                  <li>Untuk schedule broadcast yang belum jalan akan dicek dan jalankan ulang oleh sistem sekitar 1-3 jam setelah jadwal. Jika ingin melakukan duplikasi dan kirim langsung, dimohon agar broadcast schedule sebelumnya dihapus terlebih dahulu agar tidak terjadi dobel pengiriman. </li>
                  <li>Gunakan Button Stop untuk menghentikan proses broadcast. Pilih Broadcast dan Klik Stop. Fungsi Stop hanya dapat bekerja jika jumlah Waiting masih ada.</li>
                </ul>
              </div>
            </div>
            <div class="col-md-12">
              <!-- {{ selectAllTable }} -->
              <!-- loading: {{loading}} -->
              <!-- {{currentDateTimeUnix()}} -->
              <div class="table-responsive" v-if="rows.length">
                <table class="table table-striped custom-table mb-0">
                  <thead>
                    <tr>
                      <!-- <th rowspan="2">#</th> -->
                      <th rowspan="2">
                        <div class="checkbox">
                          <label>
                            <input type="checkbox" v-model="selectAllTable" />
                          </label>
                        </div>
                      </th>
                      <th rowspan="2">Sender</th>
                      <th rowspan="2">Title</th>
                      <!-- <th rowspan="2" style="width:200px;">Message</th> -->
                      <th colspan="4" class="text-center">Summary</th>
                      <th rowspan="2">Status</th>
                      <th rowspan="2">Recurring</th>
                      <th rowspan="2">Time</th>
                      <th rowspan="2">Actions</th>
                    </tr>
                    <tr>
                      <th class="text-center">Recipients</th>
                      <th class="text-center">Waiting</th>
                      <th class="text-center">Error</th>
                      <th class="text-center">Success</th>
                    </tr>
                  </thead>
                  <tbody>
                    <template v-if="loading">
                      <tr>
                        <td colspan="12">
                          <Skeleton :count="1" />
                        </td>
                      </tr>
                    </template>
                    <template v-if="rows.length">
                      <tr v-for="(row, index) in rows" :key="index">
                        <!-- <td>{{row.number}}</td> -->
                        <td>
                          <div class="checkbox">
                            <label>
                              <!-- <input type="checkbox" name="checkbox" /> -->
                              <input type="checkbox" v-model="selectedTable" :value="row" />
                            </label>
                          </div>
                        </td>
                        <td :ref="'license-' + row.id">
                          <Skeleton :count="1" />
                        </td>
                        <td>
                          <router-link :to="'/message_report/broadcast/info?id=' + row.id">{{ row.title }}</router-link>
                        </td>
                        <td class="text-right">
                          <span :class="'text text-info'"
                            v-if="row.sending_options == 2 && row.sending_schedule > currentDateTimeUnix()">
                            -
                          </span>
                          <span v-else>
                            {{ row.destination_num }}

                          </span>
                        </td>
                        <td class="text-center">
                          <span :class="'text text-info'"
                            v-if="row.sending_options == 2 && row.sending_schedule > currentDateTimeUnix()">
                            -
                          </span>
                          <span v-else>
                            <router-link v-if="((row.error_num > 0 || row.success_num > 0) && row.pending_num > 0)"
                              :to="{ path: '/message_report/broadcast_prepare', query: { broadcast_id: row.id, status: 'waiting' } }"
                              :class="'badge badge-warning'">{{ row.pending_num }}</router-link>
                            <span v-else>{{ row.pending_num }}</span>
                          </span>

                        </td>
                        <td class="text-center">
                          <router-link
                            :to="{ path: '/message_report/broadcast_prepare', query: { broadcast_id: row.id, status: 'failed' } }"
                            :class="'badge badge-danger'">{{ row.error_num }}</router-link>
                        </td>
                        <td class="text-center">
                          <router-link
                            :to="{ path: '/message_report/broadcast_prepare', query: { broadcast_id: row.id, status: 'executed' } }"
                            :class="'badge badge-success'">{{ row.success_num }}</router-link>
                        </td>
                        <td class="text-center">
                          <template v-if="row.is_send == 0">
                            <span :class="'text text-warning'">
                              <i class="fa fa-pause"></i>
                              DRAFT
                            </span>
                          </template>
                          <template v-if="row.is_send == 1">
                            <span :class="'text text-success'" v-if="row.sending_options == 1">
                              <i class="fa fa-check"></i>
                              SENT
                              <br />
                              <small v-if="row.cron_timestamp > 0">{{ formatLocalDateWithDay(row.cron_timestamp)
                              }}</small>
                              <small v-else>
                                {{ formatLocalDateWithDay(row.update_datetime) }}
                                <br />(send now)
                              </small>
                            </span>
                            <span :class="'text text-success'"
                              v-if="row.sending_options == 2 && row.sending_schedule < currentDateTimeUnix()">
                              <i class="fa fa-check"></i>
                              Sent
                              <br />
                              <small>{{ formatLocalDateWithDay(row.cron_timestamp) }}</small>
                            </span>
                            <span :class="'text text-info'"
                              v-if="row.sending_options == 2 && row.sending_schedule > currentDateTimeUnix()">
                              <i class="fa fa-clock-o"></i>
                              Scheduled
                              <br />
                              <small>{{ formatLocalDateWithDay(row.sending_schedule) }}</small>
                            </span>
                          </template>
                        </td>
                        <td>
                          <template v-if="row.is_recurring == 1">
                            <i class="fa fa-clock-o"></i>
                            {{ row.recurrence }}
                            <span>
                              <br />
                              time: {{ formatHourFromUnix(convertUTCDatetimeToUnix(row.recurrence_time)) }}
                            </span>
                            <span v-if="row.recurrence != 'daily'">
                              <br />
                              every: {{ row.recurrence_every }} {{ row.recurrence_annually_month }}
                            </span>

                            <br />end:
                            <span v-if="row.recurrence_end == 'never'">{{ row.recurrence_end }}</span>
                            <span v-else>{{ formatLocalDate(row.recurrence_end_date) }}</span>
                          </template>
                          <template v-else>-</template>
                        </td>

                        <td class="text-center">{{ formatLocalDate(row.update_datetime) }}</td>
                        <td>
                          <div class="dropdown action-label">
                            <a class="btn btn-white btn-sm btn-rounded dropdown-toggle" href="#" data-toggle="dropdown"
                              aria-expanded="false">
                              <i class="fa fa-dot-circle-o text-danger"></i> Options
                            </a>
                            <div class="dropdown-menu dropdown-menu-right">
                              <router-link :to="'/message_report/broadcast/info?id=' + row.id" class="dropdown-item">
                                <i class="fa fa-eye text-success"></i> Detail
                              </router-link>
                              <router-link :to="'/message_report/broadcast/wizard?id=' + row.id" class="dropdown-item"
                                v-if="row.is_send == '0' && row.is_import == '0'">
                                <i class="fa fa-pencil text-success"></i> Edit
                              </router-link>
                              <router-link v-if="row.is_import == '0'"
                                :to="'/message_report/broadcast/wizard?id=' + row.id + '&copy=1'" class="dropdown-item">
                                <i class="fa fa-copy text-success"></i> Duplicate
                              </router-link>

                              <!-- <a @click.prevent="detailBroadcast(row.id)" class="dropdown-item">
                                <i class="fa fa-pencil text-success"></i> Edit
                              </a>-->
                              <!-- <a class="dropdown-item">
                                <i class="fa fa-copy text-info"></i> Duplicate
                              </a>-->
                              <a @click.prevent="deleteBroadcast(row.id)" class="dropdown-item">
                                <i class="fa fa-trash-o text-danger"></i> Remove
                              </a>
                            </div>
                          </div>
                        </td>
                      </tr>
                    </template>
                    <template v-else-if="rows.length < 1 && !loading">
                      <tr>
                        <td colspan="12" class="text-center">
                          - EMPTY -
                          <!-- <lottie :options="animationsEmpty" :height="200" :width="200" /> -->
                          <div class="text-center">
                            <router-link class="btn btn-primary" :to="'/message_report/broadcast/wizard'">
                              <i class="fa fa-bullhorn"></i> Broadcast Baru
                            </router-link>
                          </div>
                        </td>
                      </tr>
                    </template>
                  </tbody>
                </table>
              </div>
              <template v-else-if="rows.length < 1 && !loading">
                <div>
                  <div class="text-center">
                    - EMPTY -
                    <!-- <lottie :options="animationsEmpty" :height="200" :width="200" /> -->
                  </div>
                  <div class="text-center">
                    <router-link class="btn btn-primary" :to="'/message_report/broadcast/wizard'">
                      <i class="fa fa-bullhorn"></i> Broadcast Baru
                    </router-link>
                  </div>
                </div>
              </template>
            </div>
          </div>
          <div class="row" v-if="rows.length > 0 && !loading">
            <div class="col-sm-12 col-md-6">
              <span class="footer__row-count__label">Displaying</span>
              <select @change="onPerPageChange(serverParams.perPage)" autocomplete="off" name="perPageSelect"
                v-model="serverParams.perPage" style="width: 100px;" class="select-to-paginasi">
                <option value="10">10 / page</option>
                <option value="20">20 / page</option>
                <option value="30">30 / page</option>
                <option value="40">40 / page</option>
                <option value="50">50 / page</option>
              </select>
              <span class="footer__row-count__label">of {{ totalRecords }} total records</span>
            </div>
            <div class="col-sm-12 col-md-6 text-right" v-if="totalRecords > serverParams.perPage">
              <a href="javascript:void(0)" @click="onPrevChange(parseInt(currentPage))" tabindex="0" class="btn"
                :class="{ disabled: parseInt(currentPage) - 1 <= 0 }">
                <span class="chevron left"></span>
                <span>Prev</span>
              </a>
              page
              <input style="width:100px;" min="1" type="number" v-model="currentPage"
                @keyup.enter="onPageChange(parseInt(currentPage))" class />
              of {{ Math.ceil(totalRecords / serverParams.perPage) }}
              <a href="javascript:void(0)" @click="onNextChange(parseInt(currentPage))" tabindex="0"
                class="footer__navigation__page-btn" :class="'btn ' + {
                  disabled:
                    parseInt(currentPage) + 1 >
                    Math.ceil(totalRecords / serverParams.perPage)
                }">
                <span>Next</span>
                <span class="chevron right"></span>
              </a>
            </div>
          </div>
        </div>
        <!-- /Page Content -->
      </div>
      <!-- /Page Wrapper -->
    </div>

    <broadcast-add :searchData="searchData" />
    <v-tour name="tourGuide" :steps="tourSteps" :callbacks="tourCallbacks"></v-tour>
  </div>
</template>

<script>
// import Lottie from "vue-lottie";
// import fileAnimationsEmpty from "@/assets/lottie/nodata.json";

import {
  currentDateTimeUnix,
  formatLocalDate,
  nFormatter,
  getCurrentMonth,
  formatDate,
  labelStatusMessage,
  formatLocalDateWithDay,
  getWhatsappNumberFromJid,
  convertUTCDatetimeToUnix,
  formatHourFromUnix
} from "@/utils/helper";
import { Skeleton } from "vue-loading-skeleton";
import BroadcastAdd from "./broadcast-add.vue";
import Multiselect from "vue-multiselect";
require("vue-multiselect/dist/vue-multiselect.min.css");

import LayoutHeader from "@/components/layouts/Header.vue";
import LayoutSidebar from "@/components/layouts/Sidebar.vue";
export default {
  components: {
    LayoutHeader,
    LayoutSidebar,
    Skeleton,
    BroadcastAdd,
    Multiselect
    // Lottie
  },
  data() {
    return {
      selectedTable: [],
      tourId: "broadcast.home",
      tourCallbacks: {
        onSkip: this.tourComplete,
        onFinish: this.tourComplete
      },
      tourSteps: [
        {
          target: '[data-tour-step="1"]', // We're using document.querySelector() under the hood
          content: `Fitur untuk mengirimkan broadcast whatsapp hingga ribuan kontak. Pastikan nomor whatsapp kamu sudah terhubung ke Waajo.`
        },
        {
          target: '[data-tour-step="2"]',
          content: "Untuk membuat pesan broadcast baru."
        },
        {
          target: '[data-tour-step="3"]',
          content:
            "Filter pencarian berdasarkan waktu, lisensi akun ataupun status.",
          params: {
            placement: "top"
          }
        }
      ],
      selectedContact: [],
      contactOptions: [],
      contactListParam: {
        license_name: "",
        license_phone_number: "",
        license_status: "",
        page: 0,
        perPage: 10
      },
      isLoading: false,
      isShowModal: false,
      loading: false,
      rows: [],
      totalRecords: 0,
      currentPage: 1,
      rowPage: 1,
      serverParams: {
        columnFilters: {
          license_id: "",
          // period: this.getCurrentMonth(),
          period: "",
          // period: "",
          is_send: "",
          is_running: "all"
        },
        page: 1,
        perPage: 10 // perPage
      }
    };
    //  isactive : true
  },
  computed: {
    selectAllTable: {
      get: function () {
        return this.rows
          ? this.selectedTable.length == this.rows.length
          : false;
      },
      set: function (value) {
        var selectedTable = [];

        if (value) {
          this.rows.forEach(function (row) {
            // selectedTable.push(row.id);
            selectedTable.push(row);
          });
        }

        this.selectedTable = selectedTable;
      }
    }
  },
  watch: {
    selectedContact: {
      handler: function (val, oldVal) {
        // console.log("val.id", val.id, val.length);
        if (val.length > 1) {
          let lengthOld = oldVal.length;
          val.splice(0, 1);
          this.selectedLicense = val;
        }
        if (val.length == 1) {
          this.serverParams.columnFilters.license_id = val[0].id;
          this.searchData();
        } else {
          this.serverParams.columnFilters.license_id = "";
          this.searchData();
        }
        // if (val.id != "") {
        //   this.serverParams.columnFilters.license_id = val.id;
        //   // console.log("val.id", val.id);
        //   this.searchData();
        // } else {
        //   this.serverParams.columnFilters.license_id = "";
        //   this.searchData();
        // }
      },
      deep: true
    }
  },
  async created() {
    let isSend = await this.$route.query.is_send;
    if (typeof isSend != "undefined" && isSend != "") {
      this.serverParams.columnFilters.is_send = await isSend;
    }
    let isRunning = await this.$route.query.is_running;
    if (typeof isRunning != "undefined" && isRunning != "") {
      this.serverParams.columnFilters.is_running = await isRunning;
    }
    await this.loadItems();
    this.asyncFind("");
    this.currentPage = this.serverParams.page;
    this.tourDetail();
  },
  methods: {
    hideActions() {
      this.selectAllTable = false;
      this.selectedTable = [];
    },
    actionDraft() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to change status of the " +
          this.selectedTable.length +
          " messages to Draft?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable
            };
            this.$store
              .dispatch("messageReport/broadcastDraftMessage", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Draft",
                  text: "The data was successfully change to Draft",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    actionStop() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to stop " +
          this.selectedTable.length +
          " broadcasts?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable
            };
            this.$store
              .dispatch("messageReport/broadcastStopMessage", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Stop",
                  text: "The data was successfully stopped",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    actionDelete() {
      if (this.selectedTable.length == 0) {
        this.$fire({
          title: "Error",
          text: "Please select at least one data",
          type: "error",
          timer: 2000
        });
        return;
      }
      this.isLoading = true;
      this.$fire({
        title:
          "Are you sure you want to permanently erase " +
          this.selectedTable.length +
          " messages?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      })
        .then(async r => {
          if (r.value == true) {
            let newParam = {
              id: this.selectedTable
            };
            this.$store
              .dispatch("messageReport/broadcastDeleteMessage", newParam)
              .then(response => {
                this.$fire({
                  title: "Success Delete",
                  text: "The data was successfully deleted",
                  type: "success",
                  timer: 2000
                });
                this.isLoading = false;
                this.selectedTable = [];
                this.selectAllTable = false;

                this.searchData();
              })
              .catch(e => {
                this.isLoading = false;
              });
          } else {
            this.isLoading = false;
          }
        })
        .catch(e => {
          this.isLoading = false;
        });
    },
    tourShow() {
      this.$tours["tourGuide"].start();
    },
    tourComplete() {
      let params = {};
      params = {
        tour_id: this.tourId
      };
      this.$store.dispatch("tour/tourComplete", params);
    },
    tourDetail() {
      let params = {};
      params = {
        tour_id: this.tourId
      };
      this.$store.dispatch("tour/tourDetail", params).then(response => {
        var { data } = response;
        if (data.id == "") {
          this.tourShow();
        }
      });
    },
    convertUTCDatetimeToUnix(utcDatetime) {
      return convertUTCDatetimeToUnix(utcDatetime);
    },
    formatHourFromUnix(utcdttz) {
      return formatHourFromUnix(utcdttz);
    },
    async detailBroadcast(id) {
      //set false dulu
      this.$store.dispatch("omniroom/setIsShowBroadcast", false);

      let dataParam = await {};
      dataParam = await {
        broadcast_id: id
      };
      let formData = await {};
      await this.$store
        .dispatch("omniwa/detailBroadcast", dataParam) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          formData = JSON.parse(data.raw);
          // formData.rowDetail = data;
          // console.log("data", data);
        });
      formData.buttons = await [];
      await this.$store
        .dispatch("omniwa/detailButtonsBroadcast", dataParam) // sesuai kan dengan method di API
        .then(response => {
          var { data } = response;
          // formData.buttons = data;
          // formData.rowDetail = data;
          // console.log("data", data);
          // console.log("datadatadatadatadata",data);

          if (data != null && data.length) {
            data.forEach((value, idx) => {
              formData.buttons.push(value.id);
            });
          }
        });
      console.log(formData);
      formData.broadcast_id = id;
      await this.$store.dispatch("omniwa/actBroadcastParamSt", formData);
      // this.showBroadcast();
      var elem = this.$refs.formBcEdit;
      elem.click();
    },
    deleteBroadcast(id) {
      this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          let dataParam = {};
          dataParam = {
            broadcast_id: id
          };
          this.$store
            .dispatch("omniwa/deleteBroadcast", dataParam) // sesuai kan dengan method di API
            .then(response => {
              this.searchData();
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              });
            });
        }
      });
    },
    formatLocalDateWithDay(value) {
      return formatLocalDateWithDay(value);
    },
    currentDateTimeUnix() {
      return currentDateTimeUnix();
    },
    limitText(count) {
      return `and ${count} other`;
    },
    customLabel({ license_name, license_phone_number }) {
      return `${license_name} – ${license_phone_number}`;
    },
    asyncFind(query) {
      this.isLoading = true;
      this.contactListParam.license_name = query;
      this.$store
        .dispatch("license/getLicenseList", this.contactListParam)
        .then(response => {
          this.isLoading = false;
          this.contactOptions = response.data.data;
          console.log("query: ", query);
          console.log("contactOptions: ", this.contactOptions);
        }) // sesuai kan dengan method di API
        .catch(error => {
          this.isLoading = false;
        });
      // ajaxFindCountry(query).then(response => {
      //   this.countries = response;
      //   this.isLoading = false;
      // });
    },
    clearAll() {
      this.selectedContact = [];
    },
    showBroadcast(newData) {
      if (typeof newData != "undefined" && newData == true) {
        this.$store.dispatch("omniroom/setIsShowBroadcast", false);

        this.selectedLicense = [];
        let formData = {
          broadcast_id: "",
          //from state
          rowDetail: {},
          is_duplicate: false,
          broadcast_id: "",
          title: "",
          provider: "whatsapp",
          license_id: "",
          to_group: [],
          to: [],
          is_group: 1, //for group set 1, for personal set 0
          is_group_type: "group", //tags/group
          message: {
            text: "",
            message_type: "text", //text,image,document
            file_url: ""
          },
          sending_options: 1,
          sending_schedule: "",
          is_recurring: 0,
          recurring_form: {
            recurrence: "",
            recurrence_every: "",
            recurrence_annually_month: "",
            recurrence_end: "never",
            recurrence_end_date: ""
          },
          is_send: 1,
          to_test: ""
        };
        this.$store.dispatch("omniwa/actBroadcastParamSt", formData);
      }
      var that = this;
      setTimeout(function () {
        var liContainer = document.getElementById("add_broadcast");
        var isShowModal = liContainer.classList.contains("show");
        // console.log("isShowModal", isShowModal);
        // this.$root.$emit("infiniteHandlerContact");
        if (isShowModal == true) {
          that.$store.dispatch("omniroom/setIsShowBroadcast", true);
        }
      }, 1000);
    },
    getWhatsappNumberFromJid(value) {
      return getWhatsappNumberFromJid(value);
    },
    labelStatusMessage(value) {
      return labelStatusMessage(value);
    },
    async setResolve(roomId) {
      await this.$fire({
        title: "Are you sure you will continue this action?",
        showDenyButton: true,
        showCancelButton: true,
        confirmButtonText: `Yes`,
        denyButtonText: `Cancel`
      }).then(async r => {
        if (typeof r.value != "undefined" && r.value == true) {
          await this.$store
            .dispatch("omniroom/setResolve", roomId) // sesuai kan dengan method di API
            .then(response => {
              this.searchData();
              this.$fire({
                title: "Success",
                text: response["msg"],
                type: "success",
                timer: 2000
              });
            });
          // .catch(error => {
          //   this.$fire({
          //     title: "Error",
          //     text: error.response.data.msg,
          //     type: "error",
          //     timer: 2000
          //   });
          //   console.log(error);
          // });
        }
      });
    },
    formatLocalDate(value) {
      return formatLocalDate(value);
    },
    updateParams(newProps) {
      // console.log("newprops", newProps);
      this.serverParams = Object.assign({}, this.serverParams, newProps);
    },
    async onPageChange(page) {
      await this.updateParams({ page: page });
      this.currentPage = page;
      await this.loadItems();
    },
    async onNextChange(page) {
      if (
        page + 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page + 1 });
        this.currentPage = page + 1;
        await this.loadItems();
      }
    },
    async onPrevChange(page) {
      // console.log("this.currentPage:: ", this.currentPage);
      if (this.currentPage == 1) {
        return;
      }
      if (
        page - 1 <=
        Math.ceil(this.totalRecords / this.serverParams.perPage)
      ) {
        await this.updateParams({ page: page - 1 });
        this.currentPage = page - 1;
        await this.loadItems();
      }
    },
    async onPerPageChange(params) {
      await this.updateParams({
        page: this.currentPage,
        perPage: this.serverParams.perPage
      });
      await this.loadItems();
    },
    formatDate(value) {
      return formatDate(value);
    },
    getCurrentMonth() {
      return getCurrentMonth();
    },
    nFormatter(value) {
      return nFormatter(value);
    },
    async searchData() {
      // this.currentPage = await 1;
      // this.serverParams.columnFilters.page = await 1;
      // await this.getListData();

      this.currentPage = 1;
      this.rows = await [];
      this.loading = await true;
      this.totalRecords = await 0;
      var params = await { page: this.currentPage };
      await this.updateParams(params);
      await this.loadItems();
      this.loading = await false;
    },
    async loadItems() {
      this.loading = await true;
      this.serverParams.page =
        this.serverParams.page - 1 <= 0
          ? await 0
          : await ((this.serverParams.page - 1) * this.serverParams.perPage);

      if (this.serverParams.columnFilters.is_send != "running") {
        this.serverParams.columnFilters.is_running = "";
      }
      await this.$store
        .dispatch("messageReport/listBroadcastV2", this.serverParams) // sesuai kan dengan method di API
        .then(response => {
          const { data } = response;
          this.totalRecords = data.totalRecords;
          this.rowPage = data.page;
          this.rows = data.data;
          this.rows.forEach((row, idx) => {
            let licenseId = row.license_id;
            this.$store
              .dispatch("license/getLicenseById", licenseId)
              .then(resLic => {
                var dataLic = resLic.data;
                // console.log("dataLic", dataLic);
                this.$refs["license-" + row.id][0].innerHTML =
                  "<b>" +
                  dataLic.license_name +
                  '</b><br /><span class="text-muted">' +
                  dataLic.license_phone_number +
                  "</span>";
              }); // sesuai kan dengan method di API
          });
          this.loading = false;
        })
        .catch(error => {
          console.log(error);
        });
    }
  },
  mounted() {
    if ($(".datetimepicker").length > 0) {
      $(".datetimepicker").datetimepicker({
        format: "DD/MM/YYYY",
        icons: {
          up: "fa fa-angle-up",
          down: "fa fa-angle-down",
          next: "fa fa-angle-right",
          previous: "fa fa-angle-left"
        }
      });
    }

    // Select 2
    if ($(".select").length > 0) {
      $(".select").select2({
        minimumResultsForSearch: -1,
        width: "100%"
      });
    }
    // Multiselect
    if ($("#customleave_select").length > 0) {
      $("#customleave_select").multiselect();
    }
    if ($("#edit_customleave_select").length > 0) {
      $("#edit_customleave_select").multiselect();
    }

    if ($(".floating").length > 0) {
      $(".floating")
        .on("focus blur", function (e) {
          $(this)
            .parents(".form-focus")
            .toggleClass(
              "focused",
              e.type === "focus" || this.value.length > 0
            );
        })
        .trigger("blur");
    }
  },
  name: "broadcast-list"
};
</script>


// WEBPACK FOOTER //
// src/views/messageReport/broadcast.vue